import React from "react"
import styled from "styled-components"

const Divider = styled.div`
    width: 100%;
    height: 1px;
    margin: 1rem 0;
    background-color: ${(props) =>
        props.color
            ? props.theme.color[props.color]
            : props.theme.color.lightGrey};
`

export default Divider
